import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Radio, Row, Upload } from 'antd'
import { FormItem } from '../../../../../styles/shared.style'
import { ButtonEx } from '../../../../../styles/button.style'
import { useDeepEffect } from '../../../../../utils/hooks'

const RemovePointTransactionForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        reason: formData.reason
      })
    }

    return () => {
      form.resetFields()
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          reason: values.reason,
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.pointTransactionId
        }
        onOk(data)
      }
    })
  }
  return (
    <Modal
      title='Update Reason'
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="Reason">
        {getFieldDecorator(`reason`, {
          })(<Input
            name="reason"
            placeholder="เหตุผล" />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

RemovePointTransactionForm.propTypes = {
  form: PropTypes.any,
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

const WrappedRemovePointTransactionForm = Form.create({ name: 'RemovePointTransactionForm' })(
  RemovePointTransactionForm
)
export default WrappedRemovePointTransactionForm
